import { useEffect, useState } from "react";
import { descargarArchivo } from "../fileDownload";
import { verPDF } from "../pdfViewer";
import EstadoCuentaTab from "./EstadoCuentaTab";

const API = "/api";
const token = () => localStorage.getItem("token");

export default function Reportes() {
  const [resumen, setResumen] = useState<any>(null);
  const [clientes, setClientes] = useState<any[]>([]);
  const [vendedores, setVendedores] = useState<any[]>([]);
  const [ventas, setVentas] = useState<any[]>([]);
  const [conciliacion, setConciliacion] = useState<any>(null);
  const [tab, setTab] = useState<"clientes" | "morosos" | "vendedores" | "ventas" | "conciliacion" | "estadocuenta">("clientes");

  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [exportando, setExportando] = useState(false);
  const [exportandoPDF, setExportandoPDF] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    fetch(`${API}/reportes/resumen`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(setResumen).catch(() => {});
    fetch(`${API}/reportes/clientes`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setClientes(d)).catch(() => {});
    fetch(`${API}/reportes/vendedores`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setVendedores(d)).catch(() => {});
  }, []);

  const cargarVentas = () => {
    const params = new URLSearchParams();
    if (fechaDesde) params.append("fecha_desde", fechaDesde);
    if (fechaHasta) params.append("fecha_hasta", fechaHasta);
    fetch(`${API}/reportes/ventas?${params.toString()}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setVentas(d)).catch(() => {});
  };

  const cargarConciliacion = () => {
    const params = new URLSearchParams();
    if (fechaDesde) params.append("fecha_desde", fechaDesde);
    if (fechaHasta) params.append("fecha_hasta", fechaHasta);
    fetch(`${API}/reportes/conciliacion?${params.toString()}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(setConciliacion).catch(() => {});
  };

  useEffect(() => {
    if (tab === "ventas") cargarVentas();
    if (tab === "conciliacion") cargarConciliacion();
  }, [tab]);

  const exportarExcel = async () => {
    setExportando(true);
    const params = new URLSearchParams();
    if (fechaDesde) params.append("fecha_desde", fechaDesde);
    if (fechaHasta) params.append("fecha_hasta", fechaHasta);
    const nombre = `ventas_${fechaDesde || "inicio"}_a_${fechaHasta || "hoy"}.xlsx`;
    await descargarArchivo(`${API}/reportes/ventas/exportar-excel?${params.toString()}`, nombre);
    setExportando(false);
  };

  const exportarPDF = async () => {
    setExportandoPDF(true);
    const params = new URLSearchParams();
    if (fechaDesde) params.append("fecha_desde", fechaDesde);
    if (fechaHasta) params.append("fecha_hasta", fechaHasta);
    const nombre = `reporte_ventas_${fechaDesde || "inicio"}_a_${fechaHasta || "hoy"}.pdf`;
    await descargarArchivo(`${API}/reportes/ventas/exportar-pdf?${params.toString()}`, nombre);
    setExportandoPDF(false);
  };

  const [busquedaVentas, setBusquedaVentas] = useState("");
  const [mostrarSugerenciasVentas, setMostrarSugerenciasVentas] = useState(false);
  const ventasFiltradas = ventas.filter(v =>
    !busquedaVentas.trim() || v.cliente.toLowerCase().includes(busquedaVentas.trim().toLowerCase())
  );
  const sugerenciasVentas = busquedaVentas.trim()
    ? Array.from(new Set(
        ventas
          .map(v => v.cliente)
          .filter(nombre => nombre?.toLowerCase().includes(busquedaVentas.trim().toLowerCase()))
      )).slice(0, 5)
    : [];
  const totalVentasFiltradas = ventasFiltradas.reduce((s, v) => s + v.total, 0);
  const reimprimirComprobante = (v: any) => {
    const base = v.tipo === "contado" ? `${API}/contado/ventas/${v.id}/recibo-pdf` : `${API}/creditos/ventas/${v.id}/recibo-pdf`;
    const nombreSlug = (v.cliente || "cliente").replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "_").slice(0, 40) || "cliente";
    verPDF(base, `recibo_${v.tipo}_${nombreSlug}_${v.id}.pdf`);
  };
  const eliminarVenta = async (v: any) => {
    const confirmado = window.confirm(
      `¿Eliminar esta venta de ${v.tipo === "contado" ? "CONTADO" : "CRÉDITO"}?\n\nCliente: ${v.cliente}\nTotal: ₡${v.total.toLocaleString()}\n\nEsta acción NO se puede deshacer. El stock de los productos vuelve al inventario.`
    );
    if (!confirmado) return;
    const url = v.tipo === "contado" ? `${API}/contado/ventas/${v.id}` : `${API}/creditos/ventas/${v.id}`;
    try {
      const r = await fetch(url, { method: "DELETE", headers: { Authorization: `Bearer ${token()}` } });
      if (!r.ok) { alert("No se pudo eliminar la venta"); return; }
      cargarVentas();
    } catch {
      alert("No se pudo eliminar la venta");
    }
  };

  const morosos = clientes.filter(c => c.moroso);
  const clientesConSaldo = [...clientes].sort((a, b) => b.saldo_pendiente - a.saldo_pendiente);

  const cardStyle = { background: "#fff", borderRadius: "16px", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" };
  const statLabel = { fontSize: "12px", fontWeight: 700, color: "#6b7280", marginBottom: "6px" };
  const statValue = { fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "24px", color: "#1a1a2e" };
  const input = { padding: "8px 10px", borderRadius: "8px", border: "1.5px solid #e5e7eb", fontSize: "13px", fontFamily: "Nunito,sans-serif" };

  const totalGeneral = resumen ? resumen.contado.total + resumen.credito.total : 0;
  const pctContado = totalGeneral > 0 && resumen ? (resumen.contado.total / totalGeneral) * 100 : 0;
  const pctCredito = totalGeneral > 0 && resumen ? (resumen.credito.total / totalGeneral) * 100 : 0;

  return (
    <div>
      <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, marginBottom: "20px", color: "#1a1a2e" }}>
        Reportes y Resultados
      </h1>

      {resumen && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "14px", marginBottom: "20px" }}>
          <div style={cardStyle}>
            <div style={statLabel}>Total facturado</div>
            <div style={statValue}>₡{totalGeneral.toLocaleString()}</div>
          </div>
          <div style={cardStyle}>
            <div style={statLabel}>Ventas de contado</div>
            <div style={{ ...statValue, color: "#22c55e" }}>₡{resumen.contado.total.toLocaleString()}</div>
            <div style={{ fontSize: "12px", color: "#9ca3af" }}>{resumen.contado.cantidad} ventas · prom. ₡{Math.round(resumen.contado.promedio).toLocaleString()}</div>
          </div>
          <div style={cardStyle}>
            <div style={statLabel}>Ventas a crédito</div>
            <div style={{ ...statValue, color: "#1565C0" }}>₡{resumen.credito.total.toLocaleString()}</div>
            <div style={{ fontSize: "12px", color: "#9ca3af" }}>{resumen.credito.cantidad} ventas · prom. ₡{Math.round(resumen.credito.promedio).toLocaleString()}</div>
          </div>
          <div style={cardStyle}>
            <div style={statLabel}>Saldo pendiente total</div>
            <div style={{ ...statValue, color: "#ef4444" }}>₡{resumen.saldo_total_pendiente.toLocaleString()}</div>
          </div>
          <div style={cardStyle}>
            <div style={statLabel}>Clientes morosos</div>
            <div style={{ ...statValue, color: resumen.clientes_morosos > 0 ? "#ef4444" : "#22c55e" }}>{resumen.clientes_morosos}</div>
          </div>
        </div>
      )}

      {resumen && totalGeneral > 0 && (
        <div style={{ ...cardStyle, marginBottom: "20px" }}>
          <div style={{ fontWeight: 800, fontSize: "14px", marginBottom: "12px" }}>Contado vs Crédito</div>
          <div style={{ display: "flex", height: "28px", borderRadius: "10px", overflow: "hidden", marginBottom: "8px" }}>
            <div style={{ width: `${pctContado}%`, background: "#22c55e", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "11px", fontWeight: 700 }}>
              {pctContado > 12 && `${pctContado.toFixed(0)}%`}
            </div>
            <div style={{ width: `${pctCredito}%`, background: "#1565C0", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "11px", fontWeight: 700 }}>
              {pctCredito > 12 && `${pctCredito.toFixed(0)}%`}
            </div>
          </div>
          <div style={{ display: "flex", gap: "16px", fontSize: "12px" }}>
            <span><span style={{ display: "inline-block", width: "10px", height: "10px", background: "#22c55e", borderRadius: "3px", marginRight: "4px" }} />Contado</span>
            <span><span style={{ display: "inline-block", width: "10px", height: "10px", background: "#1565C0", borderRadius: "3px", marginRight: "4px" }} />Crédito</span>
          </div>
        </div>
      )}

      <div style={{ display: "flex", gap: "10px", marginBottom: "16px", flexWrap: "wrap" }}>
        {[
          { id: "clientes", label: `Clientes (${clientes.length})` },
          { id: "morosos", label: `🔴 Morosos (${morosos.length})` },
          { id: "vendedores", label: `Vendedores (${vendedores.length})` },
          { id: "ventas", label: `Ventas` },
          { id: "conciliacion", label: `⚖️ Conciliación` },
          { id: "estadocuenta", label: `🧾 Estado de cuenta` },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id as any)}
            style={{ background: tab === t.id ? "#0D47A1" : "#fff", color: tab === t.id ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "10px", padding: "8px 16px", fontWeight: 700, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === "clientes" && (
        <div style={{ ...cardStyle, padding: 0, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", minWidth: "600px" }}>
            <thead>
              <tr style={{ background: "#F9FAFB", textAlign: "left" }}>
                <th style={{ padding: "12px 16px" }}>Cliente</th>
                <th style={{ padding: "12px 16px" }}>Facturado</th>
                <th style={{ padding: "12px 16px" }}>Abonado</th>
                <th style={{ padding: "12px 16px" }}>Saldo</th>
                <th style={{ padding: "12px 16px" }}>Próx. pago</th>
              </tr>
            </thead>
            <tbody>
              {clientesConSaldo.map(c => (
                <tr key={c.cliente_id} style={{ borderTop: "1px solid #f3f4f6" }}>
                  <td style={{ padding: "12px 16px", fontWeight: 700 }}>{c.nombre}</td>
                  <td style={{ padding: "12px 16px" }}>₡{c.total_facturado.toLocaleString()}</td>
                  <td style={{ padding: "12px 16px", color: "#22c55e" }}>₡{c.total_abonado.toLocaleString()}</td>
                  <td style={{ padding: "12px 16px", fontWeight: 800, color: c.saldo_pendiente > 0 ? "#ef4444" : "#22c55e" }}>₡{c.saldo_pendiente.toLocaleString()}</td>
                  <td style={{ padding: "12px 16px", color: c.moroso ? "#ef4444" : "#6b7280", fontWeight: c.moroso ? 700 : 400 }}>
                    {c.proxima_fecha_pago || "-"}{c.moroso && " (atrasado)"}
                  </td>
                </tr>
              ))}
              {clientesConSaldo.length === 0 && (
                <tr><td colSpan={5} style={{ padding: "40px", textAlign: "center", color: "#9ca3af" }}>No hay clientes registrados</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {tab === "morosos" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {morosos.map(c => (
            <div key={c.cliente_id} style={{ background: "#fff", borderRadius: "16px", padding: "16px 20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", borderLeft: "4px solid #ef4444", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontWeight: 800 }}>{c.nombre}</div>
                <div style={{ fontSize: "13px", color: "#6b7280" }}>📞 {c.telefono || "-"} · vencido: {c.proxima_fecha_pago}</div>
              </div>
              <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "18px", color: "#ef4444" }}>
                ₡{c.saldo_pendiente.toLocaleString()}
              </div>
            </div>
          ))}
          {morosos.length === 0 && (
            <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
              No hay clientes morosos 🎉
            </div>
          )}
        </div>
      )}

      {tab === "vendedores" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {vendedores.map((v, idx) => (
            <div key={v.vendedor_id ?? "sin-vendedor"} style={{ background: "#fff", borderRadius: "16px", padding: "16px 20px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: idx === 0 ? "#FEF3C7" : "#F3F4F6", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "13px", color: idx === 0 ? "#B45309" : "#6b7280" }}>
                  {idx + 1}
                </div>
                <div>
                  <div style={{ fontWeight: 800 }}>{v.nombre}</div>
                  <div style={{ fontSize: "12px", color: "#9ca3af" }}>
                    {v.cantidad_ventas != null ? `${v.cantidad_ventas} ventas` : ""}
                    {v.cantidad_contado != null && ` · ${v.cantidad_contado} contado, ${v.cantidad_credito} crédito`}
                  </div>
                </div>
              </div>
              <div style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 900, fontSize: "18px", color: "#1565C0" }}>
                ₡{v.total_vendido.toLocaleString()}
              </div>
            </div>
          ))}
          {vendedores.length === 0 && (
            <div style={{ textAlign: "center", padding: "60px", color: "#9ca3af", background: "#fff", borderRadius: "16px" }}>
              No hay ventas registradas con vendedor aún
            </div>
          )}
        </div>
      )}

      {tab === "ventas" && (
        <div>
          <div style={{ ...cardStyle, marginBottom: "16px", display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-end" }}>
            <div>
              <div style={statLabel}>Desde</div>
              <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} style={input} />
            </div>
            <div>
              <div style={statLabel}>Hasta</div>
              <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} style={input} />
            </div>
            <div style={{ position: "relative" }}>
              <div style={statLabel}>Buscar cliente</div>
              <input type="text" placeholder="Nombre del cliente..." value={busquedaVentas}
                onChange={e => setBusquedaVentas(e.target.value)}
                onFocus={() => setMostrarSugerenciasVentas(true)}
                onBlur={() => setTimeout(() => setMostrarSugerenciasVentas(false), 150)}
                style={{ ...input, minWidth: "220px" }} />
              {mostrarSugerenciasVentas && sugerenciasVentas.length > 0 && (
                <div style={{
                  position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 10,
                  background: "#fff", borderRadius: "10px", border: "1.5px solid #e5e7eb",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)", overflow: "hidden",
                }}>
                  {sugerenciasVentas.map(nombre => (
                    <div
                      key={nombre}
                      onMouseDown={() => { setBusquedaVentas(nombre); setMostrarSugerenciasVentas(false); }}
                      style={{
                        padding: "10px 14px", fontSize: "14px", fontFamily: "Nunito,sans-serif",
                        cursor: "pointer", borderBottom: "1px solid #f3f4f6", fontWeight: 700,
                      }}
                      onMouseEnter={e => (e.currentTarget.style.background = "#F0F7FF")}
                      onMouseLeave={e => (e.currentTarget.style.background = "#fff")}
                    >
                      {nombre}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button onClick={cargarVentas}
              style={{ background: "#0D47A1", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 18px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
              Filtrar
            </button>
            <button onClick={() => { setFechaDesde(""); setFechaHasta(""); }}
              style={{ background: "#fff", color: "#6b7280", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "9px 18px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
              Limpiar
            </button>
            <button onClick={exportarExcel} disabled={exportando}
              style={{ marginLeft: "auto", background: "#22c55e", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 18px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
              {exportando ? "Generando..." : "📊 Exportar a Excel"}
            </button>
            <button onClick={exportarPDF} disabled={exportandoPDF}
              style={{ background: "#ef4444", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 18px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
              {exportandoPDF ? "Generando..." : "📄 Exportar a PDF"}
            </button>
          </div>

          <div style={{ ...cardStyle, marginBottom: "16px", display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <div>
              <div style={statLabel}>Ventas en el período</div>
              <div style={statValue}>{ventasFiltradas.length}</div>
            </div>
            <div>
              <div style={statLabel}>Total en el período</div>
              <div style={{ ...statValue, color: "#1565C0" }}>₡{totalVentasFiltradas.toLocaleString()}</div>
            </div>
          </div>

          {isMobile ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {ventasFiltradas.map(v => (
                <div key={`${v.tipo}-${v.id}`} style={{ ...cardStyle, padding: "14px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                    <span style={{
                      fontSize: "11px", fontWeight: 700, padding: "3px 10px", borderRadius: "6px",
                      background: v.tipo === "contado" ? "#ECFDF5" : "#EFF6FF",
                      color: v.tipo === "contado" ? "#065F46" : "#1565C0",
                    }}>
                      {v.tipo === "contado" ? "CONTADO" : "CRÉDITO"}
                    </span>
                    <span style={{ fontSize: "12px", color: "#9ca3af" }}>{new Date(v.fecha).toLocaleDateString()}</span>
                  </div>
                  <div style={{ fontWeight: 700, fontSize: "15px", marginBottom: "4px" }}>{v.cliente}</div>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "8px" }}>
                    {v.vendedor ? `Vendedor: ${v.vendedor}` : "Sin vendedor"}
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
                    <div style={{ fontWeight: 800, fontSize: "17px", color: "#1a1a2e" }}>₡{v.total.toLocaleString()}</div>
                    <div style={{ display: "flex", gap: "6px" }}>
                      <button onClick={() => reimprimirComprobante(v)}
                        style={{ fontSize: "12px", color: "#1565C0", fontWeight: 700, background: "#EFF6FF", border: "none", borderRadius: "8px", padding: "6px 12px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                        📄 Reimprimir
                      </button>
                      <button onClick={() => eliminarVenta(v)}
                        style={{ fontSize: "12px", color: "#ef4444", fontWeight: 700, background: "#FEF2F2", border: "none", borderRadius: "8px", padding: "6px 12px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                        🗑️ Eliminar
                      </button>
                    </div>
                  </div>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "8px", paddingTop: "8px", borderTop: "1px solid #f3f4f6" }}>
                    {v.tipo === "contado" ? v.metodo_pago : `${v.estado}${v.saldo_pendiente > 0 ? ` · saldo ₡${v.saldo_pendiente.toLocaleString()}` : ""}`}
                  </div>
                </div>
              ))}
              {ventasFiltradas.length === 0 && (
                <div style={{ ...cardStyle, textAlign: "center", color: "#9ca3af", padding: "40px" }}>No hay ventas que coincidan</div>
              )}
            </div>
          ) : (
            <div style={{ ...cardStyle, padding: 0, overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", minWidth: "700px" }}>
                <thead>
                  <tr style={{ background: "#F9FAFB", textAlign: "left" }}>
                    <th style={{ padding: "12px 16px" }}>Fecha</th>
                    <th style={{ padding: "12px 16px" }}>Tipo</th>
                    <th style={{ padding: "12px 16px" }}>Cliente</th>
                    <th style={{ padding: "12px 16px" }}>Vendedor</th>
                    <th style={{ padding: "12px 16px" }}>Total</th>
                    <th style={{ padding: "12px 16px" }}>Estado / Pago</th>
                    <th style={{ padding: "12px 16px" }}>Comprobante</th>
                  </tr>
                </thead>
                <tbody>
                  {ventasFiltradas.map(v => (
                    <tr key={`${v.tipo}-${v.id}`} style={{ borderTop: "1px solid #f3f4f6" }}>
                      <td style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>{new Date(v.fecha).toLocaleDateString()}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{
                          fontSize: "11px", fontWeight: 700, padding: "3px 10px", borderRadius: "6px",
                          background: v.tipo === "contado" ? "#ECFDF5" : "#EFF6FF",
                          color: v.tipo === "contado" ? "#065F46" : "#1565C0",
                        }}>
                          {v.tipo === "contado" ? "CONTADO" : "CRÉDITO"}
                        </span>
                      </td>
                      <td style={{ padding: "12px 16px", fontWeight: 700 }}>{v.cliente}</td>
                      <td style={{ padding: "12px 16px", color: "#6b7280" }}>{v.vendedor || "-"}</td>
                      <td style={{ padding: "12px 16px", fontWeight: 800 }}>₡{v.total.toLocaleString()}</td>
                      <td style={{ padding: "12px 16px", color: "#6b7280" }}>
                        {v.tipo === "contado" ? v.metodo_pago : `${v.estado}${v.saldo_pendiente > 0 ? ` · saldo ₡${v.saldo_pendiente.toLocaleString()}` : ""}`}
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        <div style={{ display: "flex", gap: "12px" }}>
                          <button onClick={() => reimprimirComprobante(v)}
                            style={{ fontSize: "12px", color: "#1565C0", fontWeight: 700, background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "Nunito,sans-serif" }}>
                            📄 Reimprimir
                          </button>
                          <button onClick={() => eliminarVenta(v)}
                            style={{ fontSize: "12px", color: "#ef4444", fontWeight: 700, background: "none", border: "none", cursor: "pointer", padding: 0, fontFamily: "Nunito,sans-serif" }}>
                            🗑️ Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {ventasFiltradas.length === 0 && (
                    <tr><td colSpan={7} style={{ padding: "40px", textAlign: "center", color: "#9ca3af" }}>No hay ventas que coincidan</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {tab === "conciliacion" && (
        <div>
          <div style={{ ...cardStyle, marginBottom: "16px", display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-end" }}>
            <div>
              <div style={statLabel}>Desde</div>
              <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} style={input} />
            </div>
            <div>
              <div style={statLabel}>Hasta</div>
              <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} style={input} />
            </div>
            <button onClick={cargarConciliacion}
              style={{ background: "#0D47A1", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 18px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
              Filtrar
            </button>
            <button onClick={() => { setFechaDesde(""); setFechaHasta(""); }}
              style={{ background: "#fff", color: "#6b7280", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "9px 18px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
              Limpiar
            </button>
          </div>

          {conciliacion && (
            <>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "14px", marginBottom: "16px" }}>
                <div style={cardStyle}>
                  <div style={statLabel}>Total ventas ({conciliacion.cantidad_ventas})</div>
                  <div style={{ ...statValue, color: "#22c55e" }}>₡{conciliacion.total_ventas.toLocaleString()}</div>
                  <div style={{ fontSize: "12px", color: "#9ca3af" }}>Contado ₡{conciliacion.total_contado.toLocaleString()} · Crédito ₡{conciliacion.total_credito.toLocaleString()}</div>
                </div>
                <div style={cardStyle}>
                  <div style={statLabel}>Total gastos ({conciliacion.cantidad_gastos})</div>
                  <div style={{ ...statValue, color: "#ef4444" }}>₡{conciliacion.total_gastos.toLocaleString()}</div>
                </div>
                <div style={cardStyle}>
                  <div style={statLabel}>Balance del período</div>
                  <div style={{ ...statValue, color: conciliacion.balance >= 0 ? "#22c55e" : "#ef4444" }}>
                    {conciliacion.balance >= 0 ? "+" : ""}₡{conciliacion.balance.toLocaleString()}
                  </div>
                </div>
              </div>

              <div style={cardStyle}>
                <div style={{ fontWeight: 800, fontSize: "14px", marginBottom: "12px" }}>Gastos por categoría</div>
                {conciliacion.gastos_por_categoria.length === 0 && (
                  <div style={{ color: "#9ca3af", fontSize: "13px" }}>No hay gastos registrados en este período</div>
                )}
                {conciliacion.gastos_por_categoria.map((g: any) => {
                  const pct = conciliacion.total_gastos > 0 ? (g.total / conciliacion.total_gastos) * 100 : 0;
                  return (
                    <div key={g.categoria} style={{ marginBottom: "10px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                        <span style={{ fontWeight: 700 }}>{g.categoria}</span>
                        <span>₡{g.total.toLocaleString()} ({pct.toFixed(0)}%)</span>
                      </div>
                      <div style={{ background: "#F3F4F6", borderRadius: "6px", height: "10px", overflow: "hidden" }}>
                        <div style={{ width: `${pct}%`, height: "10px", background: "#ef4444" }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      )}
      {tab === "estadocuenta" && <EstadoCuentaTab />}
    </div>
  );
}
